import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Dashboard } from '../dashboard/dashboard';
import { Payments } from '../dashboard/payments';
import { CreateAuction } from '../dashboard/create_auction';
import { Masks } from '../dashboard/masks';
import { EditMask } from '../dashboard/edit_mask';
// import { EditAuction } from '../dashboard/edit_auction';
import { NotFound } from '../notfound';
import { PaymentCancelled } from '../paymentCancelled';
import { PaymentSuccess } from '../paymentSuccess';
import { UsersList } from '../dashboard/users';
import { EditGroup } from '../dashboard/edit_group';
import { EnrolledAuctions } from '../dashboard/enrolled_auctions';
import { getLoggedUser } from '../../state/user';
import { Categories } from '../dashboard/categories';
import { Organizations } from '../dashboard/organizations';
import { AuctionDetails } from '../home/auctionDetails';
import { RentalYards } from '../services/rentalYards';
import { SegreggationsEvaluation } from '../services/segreggationsEvaluation';
import { Transportation } from '../services/transportation';
import { Recycling } from '../services/recycling';
import { AuctionsOld } from '../auctions';
import { EditCategory } from '../dashboard/edit_category';
import { EditOrganization } from '../dashboard/edit_organization';
import { EnrolledUsers } from '../dashboard/enrolled_users';
import { ImagePanel } from '../dashboard/image_panel';
import { EnquiriesDetails } from '../dashboard/enquiries_details';
import { Contracts } from '../dashboard/contracts';
import { EditProfile } from '../dashboard/edit_profile';
import { Winners } from '../dashboard/reports/winners';
import { AuctionBiddingReport } from '../dashboard/reports/auction_bid_report';
import { SalesReport } from '../dashboard/reports/sales_report';
import { Banners } from '../dashboard/banners';
import { PaymentDetails } from '../dashboard/payment_details';
import { BulkMail } from '../dashboard/bulk_mail';
import { ReportsPosition } from '../dashboard/reports/reports_position';
import { Wallet } from '../dashboard/wallet';
import { UsersWallet } from '../dashboard/users-wallet';
import { SiteVisit } from '../dashboard/site_visit';
import { WalletPaymentSuccess } from '../walletPaymentSuccess';
import { WalletPaymentCancelled } from '../WalletPaymentCancelled';
import { WalletWithdrawals } from '../dashboard/wallet_withdrawals';
import { getUserProfile } from '../../models/users';
import { BlackList } from '../dashboard/blacklist';
import { CompanyRegistration } from '../auth/registration_company';
import { Modal } from 'react-bootstrap';
import { Support } from '../support';
import { TermsPanel } from '../dashboard/terms';
import { ClientPayment } from '../ClientPayment';
import { ClientPaymentSuccess } from '../ClientPaymentSuccess';
import { ClientPaymentCancelled } from '../ClientPaymentCancelled';
import { AdminClientPayments } from '../dashboard/client_payments';
import { ClientRegistration } from '../auth/registration_client';
import { ClientsList } from '../dashboard/clients';
import { AdditionalPanel } from '../dashboard/additional';
import i18n from '../../i18n';
import { DashboardAuctionEvaluation } from '../dashboard/dashboard_auc_eval';
import { DashboardUserAnalysis } from '../dashboard/dashboard_user_analysis';
import { DashboardSalesEvaluation } from '../dashboard/dashboard_sales_eval';
import { DashboardAuctionMaterials } from '../dashboard/dashboard_auc_material';
import { MyNotifications } from '../dashboard/notifications';
import { EnrollCustom } from '../enroll-custom';
import { ApprovedAuctions } from '../dashboard/approved_auctions';
import { PaymentBulkSuccess } from '../bulkPaymentSuccess';
import { WalletSummary } from '../dashboard/reports/wallet_summary';
import { EnrolledUsersManage } from '../dashboard/enrolled_users_mgmt';
import { Refund } from '../dashboard/pages/Refund/Refund';
import { FinalReport } from '../dashboard/pages/Report/FinalReport';
import { AuctionApprovalList } from '../dashboard/pages/AuctionApproval/AuctionApprovalList';
import AuctionApprovalDetail from '../dashboard/pages/AuctionApproval/AuctionApprovalDetail.jsx';
import { WinningBidList } from '../dashboard/pages/WinningBids/WinningBidList.jsx';
import AuctionPayment from '../dashboard/pages/ClientTransaction/AuctionPayment.jsx';
import { MzadcomPaymentList } from '../dashboard/pages/MzadcomPayment/MzadcomPaymentList.jsx';
import AuctionPaymentDetails from '../dashboard/pages/ClientTransaction/AuctionPaymentDetails.jsx';
import { MyBids } from '../dashboard/pages/MyBids/MyBidsList.jsx';
import { AuctionsListNew } from '../dashboard/pages/Auction/AuctionsList.jsx';
import { ManagementDashboard } from '../dashboard/pages/Management/ManagementDashboard.jsx';
import AuctionList from '../dashboard/pages/Management/AuctionList.jsx';
import WinnersList from '../dashboard/pages/Management/WinnersList.jsx';
import EnrollmentList from '../dashboard/pages/Management/EnrollmentList.jsx';
import AuctionTracking from '../dashboard/pages/MyBids/AuctionTracking.jsx';
import { SiteVisitForm } from '../home/pages/SiteVisit/SiteVisit.jsx';
import { SiteVisitList } from '../dashboard/pages/SiteVisitProjects/SiteVisitProjects.jsx';
import { SiteVisitRequests } from '../dashboard/pages/SiteVisitRequests/SiteVisitRequests.jsx';
import { SiteVisitFormDetails } from '../dashboard/pages/SiteVisitDetails/SiteVisitDetails.jsx';
import ContactPage from '../home/pages/ContactUs/ContactPage.jsx';
import PrivacyPolicyPage from '../home/pages/PrivacyPolicy/PrivacyPolicyPage.jsx';
import TermsOfServicePage from '../home/pages/TermsOfService/TermsOfServicePage.jsx';
import AboutUs from '../home/pages/AboutUs/AboutUsPage.jsx';
import { ClientDashboard } from '../dashboard/pages/ClientDashboard/ClientDashboard.jsx';
import { AuctionLiked } from '../dashboard/pages/Auction/AuctionLiked.jsx';
import GroupList from '../dashboard/pages/Group/GroupList.jsx';
import GroupCreate from '../dashboard/pages/Group/GroupCreate.jsx';
import GroupUpdate from '../dashboard/pages/Group/GroupUpdate.jsx';
import LoginNew from '../home/pages/Auth/Login.jsx';
import LoginWithOtp from '../home/pages/Auth/LoginWithOtp.jsx';
import ForgotPasswordNew from '../home/pages/Auth/ForgetPassword.jsx';
import ForgotPasswordConfirmation from '../home/pages/Auth/ForgotPasswordConfirmation.jsx';
import VerifyOtp from '../home/pages/Auth/VerifyOtp.jsx';
import RegisterNew from '../home/pages/Auth/Register.jsx';
import ResetPasswordNew from '../home/pages/Auth/ResetPassword.jsx';
import { AuctionWishlist } from '../dashboard/pages/Auction/AuctionWishlist.jsx';
import VehicleRegistration from '../dashboard/pages/VehicleRegistration/VehicleRegistration.jsx';
import { VehicleList } from '../dashboard/pages/VehicleList/VehicleList.jsx';
import LoadingProgressDashboard from '../dashboard/pages/LoadingProgress/LoadingProgress.jsx';
import FleetManagement from '../dashboard/pages/LoadingManagement/LoadingManagement.jsx';
import { DeliverySiteList } from '../dashboard/pages/DeliverySiteList/DeliverySiteList.jsx';
import DeliverySiteUpdate from '../dashboard/pages/DeliverySiteList/DeliverySiteUpdate.jsx';
import WeighbridgeTicketList from '../dashboard/pages/WeighbridgeTicketList/WeighbridgeTicketList.jsx';
import BulkVehicleReg from '../home/pages/VehicleReg/VehicleReg.jsx';
import SellersList from '../home/pages/Sellers/Sellers.jsx';
import AuctionMap from '../home/pages/Map/Map.jsx';
import NavbarClient from '../home/pages/Landing/components/NavbarClient.jsx';
import { Auctions } from '../home/pages/Auctions/Auctions.jsx';
import ReportNew from '../dashboard/pages/Report/Report.jsx';
import CashFlowDashboard from '../dashboard/pages/CashFlowDashboard/CashFlowDashboard.jsx';
import AuctionPaymentCashFlow from '../dashboard/pages/CashFlowDashboard/AuctionPaymentCashFlow.jsx';
import AuctionEnrollmentCashFlow from '../dashboard/pages/CashFlowDashboard/AuctionEnrollmentCashFlow.jsx';
import AuctionClientPaymentDetails from '../dashboard/pages/CashFlowDashboard/AuctionClientPaymentDetails.jsx';
import WalletWithdrawalCashFlow from '../dashboard/pages/CashFlowDashboard/WalletWithdrawalCashFlow.jsx';
import WalletRechargeCashFlow from '../dashboard/pages/CashFlowDashboard/WalletRechargeCashFlow.jsx';
import AuctionBidderPaymentDetails from '../dashboard/pages/CashFlowDashboard/AuctionBidderPaymentDetails.jsx';
import { AuctionsListGrouped } from '../home/pages/AuctionsListGrouped/AuctionsListGrouped.jsx';
import { MyAuctions } from '../home/pages/MyAuctions/MyAuctions.jsx';
import { AuctionCreate } from '../dashboard/pages/Auction/AuctionCreate.jsx';
import { EditAuctionTab } from '../dashboard/pages/Auction/components/Edit/EditAution.jsx';
import { AttributeCreate } from '../dashboard/pages/Attribute/components/CreateAttribute.jsx';
import { AttributesList } from '../dashboard/pages/Attribute/Attribute.jsx';
import { LandingPage } from '../home/pages/Landing/LandingPage.jsx';
import { AuctionEnrollment } from '../home/pages/Enroll/AuctionEnrollment.jsx';
import { AuctionCalendar } from '../home/pages/AuctionCalendar/AuctionCalendar.jsx';
import { WalletRecharge } from '../dashboard/pages/Wallet/WalletRecharge.jsx';
import { AuctionDetailsNew, AuctionDetailsNewWrapper } from '../home/pages/AuctionDetails/AuctionDetails.jsx';

const user = getLoggedUser();
export class Topbar extends React.Component {
  constructor() {
    super();
    this.state = {
      showPopup: false,
      is_more_help: false,
      is_loading: false,
      wallet_amount: 0,
      mzadcom_due: 0,
    };
    this.checkUserWallet = this.checkUserWallet.bind(this);
  }

  componentDidMount() {
    let is_logged_in = this.props.is_logged;
    if (is_logged_in) {
      this.checkUserWallet();
    }
  }

  hideSideBar() {
    document.body.classList.remove('active');
  }

  async checkUserWallet() {
    this.setState({ is_loading: true });
    const response = await getUserProfile();
    if (response && response.success) {
      let data = response.data;
      let meta = response.meta;
      this.setState({ is_loading: false });
      this.setState({ wallet_amount: data.wallet_amount, mzadcom_due: meta.mzadcom_due });
    } else {
      this.setState({ is_loading: false });
    }
  }

  handleCallbackForMore = (flag) => {
    this.setState({
      is_more_help: flag,
    });
  };

  handleCallbackForSupport = (flag) => {
    this.setState({
      showPopup: flag,
    });
  };

  render() {
    let is_logged_in = this.props.is_logged;

    const currentPath = this.props.location?.pathname || window.location.pathname;
    const hideLayoutRoutes = ['/site-visit'];
    const hideLayout = hideLayoutRoutes.includes(currentPath);
    const isHomepage = currentPath === '/';

    return (
      <React.Fragment>
        {!hideLayout &&
          (isHomepage ? (
            <NavbarClient
              is_logged_in={is_logged_in}
              wallet_amount={this.state.wallet_amount}
              due_amount={this.state.mzadcom_due}
              homePage={true}
            />
          ) : (
            <NavbarClient
              is_logged_in={is_logged_in}
              wallet_amount={this.state.wallet_amount}
              due_amount={this.state.mzadcom_due}
              is_loading={this.state.is_loading}
            />
          ))}

        <Routes>
          <Route
            path="/"
            element={<LandingPage callbackForSupport={this.handleCallbackForSupport} />}
          />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/my-auctions" element={<MyAuctions />} />

          <Route
            path="/auc-calendar"
            element={<AuctionCalendar callbackForSupport={this.handleCallbackForSupport} />}
          />
          <Route
            path="/comp-registration"
            element={
              localStorage.getItem('is_logged_in') ? (
                <Navigate to="/" replace />
              ) : (
                <CompanyRegistration />
              )
            }
          />
          <Route
            path="/client-registration"
            element={
              localStorage.getItem('is_logged_in') ? (
                <Navigate to="/" replace />
              ) : (
                <ClientRegistration />
              )
            }
          />
          <Route
            path="/login"
            element={
              localStorage.getItem('is_logged_in') ? <Navigate to="/" replace /> : <LoginNew />
            }
          />
          <Route
            path="/login/otp"
            element={
              localStorage.getItem('is_logged_in') ? <Navigate to="/" replace /> : <LoginWithOtp />
            }
          />
          <Route
            path="/login/otp-verify-email/:token"
            element={
              localStorage.getItem('is_logged_in') ? <Navigate to="/" replace /> : <VerifyOtp />
            }
          />

          <Route
            path="/login/otp-verify-mobile"
            element={
              localStorage.getItem('is_logged_in') ? <Navigate to="/" replace /> : <VerifyOtp />
            }
          />
          <Route
            path="/forgot-password"
            element={
              localStorage.getItem('is_logged_in') ? (
                <Navigate to="/" replace />
              ) : (
                <ForgotPasswordNew />
              )
            }
          />
          <Route
            path="/forgot-password-confirmation"
            element={
              localStorage.getItem('is_logged_in') ? (
                <Navigate to="/" replace />
              ) : (
                <ForgotPasswordConfirmation />
              )
            }
          />
          <Route
            path="/register"
            element={
              localStorage.getItem('is_logged_in') ? <Navigate to="/" replace /> : <RegisterNew />
            }
          />

          <Route
            path="/password/reset/:token"
            element={
              localStorage.getItem('is_logged_in') ? (
                <Navigate to="/" replace />
              ) : (
                <ResetPasswordNew />
              )
            }
          />
          <Route
            path="/grouped-auctions/:id"
            element={<AuctionsListGrouped callbackForSupport={this.handleCallbackForSupport} />}
          />
          <Route
            path="/auction-details/:id"
            element={
              <AuctionDetailsNew callbackForSupport={this.handleCallbackForSupport} />
            }
          />
          <Route
            path="/sellers"
            element={<SellersList callbackForSupport={this.handleCallbackForSupport} />}
          />
          <Route
            path="/auction-details-old/:id"
            element={<AuctionDetails callbackForSupport={this.handleCallbackForSupport} />}
          />
          <Route
            path="/map"
            element={<AuctionMap callbackForSupport={this.handleCallbackForSupport} />}
          />

          <Route
            exact
            path="/auctions"
            element={<Auctions callbackForSupport={this.handleCallbackForSupport} />}
          />

          <Route
            exact
            path="/auctions-old"
            element={<AuctionsOld callbackForSupport={this.handleCallbackForSupport} />}
          />
          <Route path="/services" element={<RentalYards />} />
          <Route path="/services/rental-yards" element={<RentalYards />} />
          <Route path="/services/segreggations-evaluation" element={<SegreggationsEvaluation />} />
          <Route path="/services/transportation" element={<Transportation />} />
          <Route path="/services/recycling" element={<Recycling />} />

          <Route path="/site-visit/" element={<SiteVisitForm />} />

          {/** Protected Routes */}
          <Route
            path="/management"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'A' || user.role === 'CE' || user.role === 'GM') ? (
                // <Management />
                <ManagementDashboard />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/client-dashboard"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'C' ? (
                <ClientDashboard />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/cash-flow"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'CE' || user.role === 'GM' || user.role === 'F') ? (
                <CashFlowDashboard />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/cash-flow/auction-payment"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'CE' || user.role === 'GM' || user.role === 'F') ? (
                <AuctionPaymentCashFlow />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/cash-flow/auction-payment/bidder/details"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'CE' || user.role === 'GM' || user.role === 'F') ? (
                <AuctionBidderPaymentDetails />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/cash-flow/auction-payment/client/details"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'CE' || user.role === 'GM' || user.role === 'F') ? (
                <AuctionClientPaymentDetails />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/cash-flow/auction-enrollment"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'CE' || user.role === 'GM' || user.role === 'F') ? (
                <AuctionEnrollmentCashFlow />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/cash-flow/wallet/recharge"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'CE' || user.role === 'GM' || user.role === 'F') ? (
                <WalletRechargeCashFlow />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/cash-flow/wallet/withdrawal"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'CE' || user.role === 'GM' || user.role === 'F') ? (
                <WalletWithdrawalCashFlow />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/enrollment-overview"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'A' ||
                user.role === 'C' ||
                user.role === 'CE' ||
                user.role === 'GM') ? (
                <EnrollmentList />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/auction-overview"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'A' ||
                user.role === 'C' ||
                user.role === 'CE' ||
                user.role === 'GM') ? (
                <AuctionList />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/winner-overview"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'A' ||
                user.role === 'C' ||
                user.role === 'CE' ||
                user.role === 'GM') ? (
                <WinnersList />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/dashboard"
            element={localStorage.getItem('is_logged_in') ? <Dashboard /> : <NotFound />}
          />
          <Route
            path="/notifications"
            element={localStorage.getItem('is_logged_in') ? <MyNotifications /> : <NotFound />}
          />
          <Route
            path="/dashboard-auc-eval"
            element={
              localStorage.getItem('is_logged_in') ? <DashboardAuctionEvaluation /> : <NotFound />
            }
          />
          <Route
            path="/dashboard-user-analysis"
            element={
              localStorage.getItem('is_logged_in') ? <DashboardUserAnalysis /> : <NotFound />
            }
          />
          <Route
            path="/dashboard-sales-eval"
            element={
              localStorage.getItem('is_logged_in') ? <DashboardSalesEvaluation /> : <NotFound />
            }
          />
          <Route
            path="/dashboard-auc-materials"
            element={
              localStorage.getItem('is_logged_in') ? <DashboardAuctionMaterials /> : <NotFound />
            }
          />
          <Route
            path="/profile"
            element={localStorage.getItem('is_logged_in') ? <EditProfile /> : <NotFound />}
          />
          <Route
            path="/enroll/:id"
            element={localStorage.getItem('is_logged_in') ? <AuctionEnrollment /> : <NotFound />}
          />
          <Route
            path="/custom-enroll/:id"
            element={localStorage.getItem('is_logged_in') ? <EnrollCustom /> : <NotFound />}
          />
          <Route
            path="/payments"
            element={
              localStorage.getItem('is_logged_in') && (user.role === 'A' || user.role === 'M') ? (
                <Payments />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/client-payments"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'A' || user.role === 'PM' || user.role === 'OM') ? (
                <AdminClientPayments />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/create_auction"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <CreateAuction />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/auction/create"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <AuctionCreate />
              ) : (
                <NotFound />
              )
            }
          />
          {/* <Route
            path="/edit_auction/:id"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <EditAuction />
              ) : (
                <NotFound />
              )
            }
          /> */}

          <Route
            path="/edit_auction/:auction"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <EditAuctionTab />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/attributes"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <AttributesList />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/attributes/create"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <AttributeCreate />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/attributes/edit/:id"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <AttributeCreate />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/auctions-list"
            element={localStorage.getItem('is_logged_in') ? <AuctionsListNew /> : <NotFound />}
          />
          <Route
            path="/auction_approval"
            element={
              localStorage.getItem('is_logged_in') && user.role !== 'U' ? (
                <AuctionApprovalList />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/auction_approval/:groupId"
            element={
              localStorage.getItem('is_logged_in') && user.role !== 'U' ? (
                <AuctionApprovalDetail />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/approved_auctions"
            element={localStorage.getItem('is_logged_in') ? <ApprovedAuctions /> : <NotFound />}
          />

          <Route
            path="/groups"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <GroupList />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/groups/create"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <GroupCreate />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/groups/edit/:id"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <GroupUpdate />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/edit_group/:id"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <EditGroup />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/masks"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? <Masks /> : <NotFound />
            }
          />
          <Route
            path="/edit_mask/:id"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <EditMask />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/categories"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <Categories />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/edit_category/:id"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <EditCategory />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/organizations"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <Organizations />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/edit_organization/:id"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <EditOrganization />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/banners"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? <Banners /> : <NotFound />
            }
          />
          <Route
            path="/blacklist"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <BlackList />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/payment-success/"
            element={localStorage.getItem('is_logged_in') ? <PaymentSuccess /> : <NotFound />}
          />
          <Route
            path="/bulk-payment-success/"
            element={localStorage.getItem('is_logged_in') ? <PaymentBulkSuccess /> : <NotFound />}
          />
          <Route
            path="/payment-cancelled"
            element={localStorage.getItem('is_logged_in') ? <PaymentCancelled /> : <NotFound />}
          />
          <Route
            path="/wallet-payment-success/"
            element={
              localStorage.getItem('is_logged_in') ? (
                <WalletPaymentSuccess callbackForSupport={this.handleCallbackForSupport} />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/wallet-payment-cancelled"
            element={
              localStorage.getItem('is_logged_in') ? (
                <WalletPaymentCancelled callbackForSupport={this.handleCallbackForSupport} />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/client-payment-success/"
            element={
              localStorage.getItem('is_logged_in') ? (
                <ClientPaymentSuccess callbackForSupport={this.handleCallbackForSupport} />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/client-payment-cancelled/"
            element={
              localStorage.getItem('is_logged_in') ? (
                <ClientPaymentCancelled callbackForSupport={this.handleCallbackForSupport} />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/users"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'A' ||
                user.role === 'PM' ||
                user.role === 'OM' ||
                user.role === 'GM' ||
                user.role === 'CE' ||
                user.role === 'M') ? (
                <UsersList />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/clients"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'A' ||
                user.role === 'PM' ||
                user.role === 'OM' ||
                user.role === 'GM' ||
                user.role === 'CE' ||
                user.role === 'M') ? (
                <ClientsList />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/site_visit"
            element={
              localStorage.getItem('is_logged_in') && user.role !== 'C' ? (
                <SiteVisit />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/site-visit-projects"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'PM' ||
                user.role === 'HSE' ||
                user.role === 'O' ||
                user.role === 'GM') ? (
                <SiteVisitList />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/site-visit-requests"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'PM' ||
                user.role === 'HSE' ||
                user.role === 'O' ||
                user.role === 'GM') ? (
                <SiteVisitRequests />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/site-visit-requests/:id/edit"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'PM' ||
                user.role === 'HSE' ||
                user.role === 'O' ||
                user.role === 'GM') ? (
                <SiteVisitFormDetails />
              ) : (
                <NotFound />
              )
            }
          />

          <Route path="/site-pass-request" element={<BulkVehicleReg />} />

          <Route
            path="/vehicle-registration"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'PM' ||
                user.role === 'HSE' ||
                user.role === 'O' ||
                user.role === 'GM') ? (
                <VehicleRegistration />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/vehicles"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'PM' ||
                user.role === 'HSE' ||
                user.role === 'O' ||
                user.role === 'GM') ? (
                <VehicleList />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/vehicle/:id/edit"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'PM' ||
                user.role === 'HSE' ||
                user.role === 'O' ||
                user.role === 'GM') ? (
                <VehicleRegistration />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/delivery-site-list"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'PM' ||
                user.role === 'HSE' ||
                user.role === 'O' ||
                user.role === 'GM') ? (
                <DeliverySiteList />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/weighbridge-ticket-list"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'PM' ||
                user.role === 'HSE' ||
                user.role === 'O' ||
                user.role === 'GM') ? (
                <WeighbridgeTicketList />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/delivery-site/edit/:id"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'PM' ||
                user.role === 'HSE' ||
                user.role === 'O' ||
                user.role === 'GM') ? (
                <DeliverySiteUpdate />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/loading-progress"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'GM' || user.role === 'CE' || user.role === 'C') ? (
                <LoadingProgressDashboard />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/loading-management"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'PM' ||
                user.role === 'HSE' ||
                user.role === 'O' ||
                user.role === 'GM') ? (
                <FleetManagement />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/users-wallet"
            element={
              localStorage.getItem('is_logged_in') && ['A', 'F', 'CE', 'GM'].includes(user.role) ? (
                <UsersWallet />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/auction-payment"
            element={
              localStorage.getItem('is_logged_in') && ['F'].includes(user.role) ? (
                <AuctionPayment />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/auction-payment/:groupId"
            element={
              localStorage.getItem('is_logged_in') && ['F'].includes(user.role) ? (
                <AuctionPaymentDetails />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/wallet_summary"
            element={
              localStorage.getItem('is_logged_in') && user.role !== 'U' ? (
                <WalletSummary />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/withdraw-requests"
            element={
              localStorage.getItem('is_logged_in') && (user.role === 'A' || user.role === 'F') ? (
                <WalletWithdrawals />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/enrolled_auctions"
            element={localStorage.getItem('is_logged_in') ? <EnrolledAuctions /> : <NotFound />}
          />
          <Route
            path="/my_auctions"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'U' ? <MyBids /> : <NotFound />
            }
          />
          <Route
            path="/track/:auctionId"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'U' ? (
                <AuctionTracking />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/auction/liked"
            element={localStorage.getItem('is_logged_in') ? <AuctionLiked /> : <NotFound />}
          />

          <Route
            path="/auction/wishlist"
            element={localStorage.getItem('is_logged_in') ? <AuctionWishlist /> : <NotFound />}
          />

          <Route
            path="/winning_bids"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'U' ? (
                <WinningBidList />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/mzadcom-payment"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'U' ? (
                <MzadcomPaymentList />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/auction_bid_report"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'A' ||
                user.role === 'C' ||
                user.role === 'PM' ||
                user.role === 'OM' ||
                user.role === 'GM' ||
                user.role === 'CE' ||
                user.role === 'M') ? (
                <AuctionBiddingReport />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/sales_report"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'A' ||
                user.role === 'PM' ||
                user.role === 'OM' ||
                user.role === 'GM' ||
                user.role === 'CE' ||
                user.role === 'M') ? (
                <SalesReport />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/final_report"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'A' ||
                user.role === 'PM' ||
                user.role === 'OM' ||
                user.role === 'GM' ||
                user.role === 'CE' ||
                user.role === 'M') ? (
                <FinalReport />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/position_report"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'A' ||
                user.role === 'PM' ||
                user.role === 'OM' ||
                user.role === 'GM' ||
                user.role === 'CE' ||
                user.role === 'M') ? (
                <ReportsPosition />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/winners"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'A' ||
                user.role === 'C' ||
                user.role === 'PM' ||
                user.role === 'OM' ||
                user.role === 'GM' ||
                user.role === 'CE' ||
                user.role === 'M') ? (
                <Winners />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/reports"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'A' ||
                user.role === 'C' ||
                user.role === 'PM' ||
                user.role === 'OM' ||
                user.role === 'GM' ||
                user.role === 'CE' ||
                user.role === 'M') ? (
                <ReportNew />
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/enrolled_users"
            element={
              localStorage.getItem('is_logged_in') ? (
                user.role === 'GM' || user.role === 'CE' ? (
                  <EnrolledUsersManage />
                ) : user.role === 'A' ||
                  user.role === 'PM' ||
                  user.role === 'OM' ||
                  user.role === 'F' ||
                  user.role === 'M' ? (
                  <EnrolledUsers />
                ) : (
                  <NotFound />
                )
              ) : (
                <NotFound />
              )
            }
          />
          <Route
            path="/image_uploader/:auction"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <ImagePanel />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/enquiries_details/:auction"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <EnquiriesDetails />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/contracts/:auction"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <Contracts />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/terms/:auction"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <TermsPanel />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/additional/:auction"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <AdditionalPanel />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/refund"
            element={
              localStorage.getItem('is_logged_in') &&
              (user.role === 'A' ||
                user.role === 'PM' ||
                user.role === 'F' ||
                user.role === 'OM' ||
                user.role === 'GM' ||
                user.role === 'CE') ? (
                <Refund />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/composer"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <BulkMail />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/refund/:reference"
            element={
              localStorage.getItem('is_logged_in') && user.role === 'A' ? (
                <PaymentDetails />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/wallet"
            element={
              localStorage.getItem('is_logged_in') ? (
                <Wallet callbackForSupport={this.handleCallbackForSupport} />
              ) : (
                <NotFound />
              )
            }
          />

          <Route
            path="/client-payment"
            element={
              localStorage.getItem('is_logged_in') ? (
                <ClientPayment callbackForSupport={this.handleCallbackForSupport} />
              ) : (
                <NotFound />
              )
            }
          />

          {/* <Route
            path="/wallet-manage"
            element={
              localStorage.getItem('is_logged_in') ? (
                <WalletManage callbackForSupport={this.handleCallbackForSupport} />
              ) : (
                <NotFound />
              )
            }
          /> */}

          <Route
            path="/wallet-manage"
            element={
              localStorage.getItem('is_logged_in') ? (
                <WalletRecharge callbackForSupport={this.handleCallbackForSupport} />
              ) : (
                <NotFound />
              )
            }
          />

          <Route path="*" exact={true} element={<NotFound />} />
        </Routes>
        <Modal
          size="lg"
          show={this.state.showPopup}
          onHide={() => this.setState({ showPopup: false })}
          animation={true}
          dialogClassName="modal-90w"
          id="support-modal"
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header className="text-dark border-0 text-center">
            <h4 className="h4 w-100 my-3">
              {this.state.is_more_help ? i18n.t('support_pick_cat') : i18n.t('support')}
            </h4>
            <button
              type="button"
              className="btn-close"
              onClick={() => this.setState({ showPopup: false })}
            >
              <i className="fa fa-times" />
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="m-4">
              <Support callbackForMore={this.handleCallbackForMore} />
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}
export function TopbarWithRouter(props) {
  const location = useLocation();
  return <Topbar {...props} location={location} />;
}
